import React from "react";
import Header from "../common/header/Header";
import Contact from "../contact/Contact";

const ContactPage = () => {
  return (
    <div>
      <Header />
      <Contact />
    </div>
  );
};

export default ContactPage;
